// extracted by mini-css-extract-plugin
export default {"container":"Transfer_container__U3kKg","main":"Transfer_main__SfAsf","body":"Transfer_body__mgPlZ"};